import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// export const loginUser = makeThunk({url: LOGIN});

const initialState = {
  loading: false,
  isLoading: false,
  isSideBarOpen: true,
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setSideBarOpen: (state, action) => {
      state.isSideBarOpen = action.payload;
    },
  },

  extraReducers: (builder) => {
    // handleCommonCases(builder, loginUser, {
    //   onFulfilled: (state, action) => {},
    // });
  },
});

export default commonSlice.reducer;
export const { setSideBarOpen } = commonSlice.actions;

